//? 抽奖结果展示
<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="600px"
    class="c-Result"
    :append-to-body="true"
  >
    <div class="dialog-title" slot="title">
      <span :style="{ fontSize: '18px' }">
        抽奖结果
      </span>
      <span :style="{ fontSize: '14px', color: '#999', marginLeft: '10px' }">
        (点击号码可以删除)
      </span>
    </div>
    <div
      v-for="(item, index) in resultList"
      :key="index"
      class="listrow"
      @click="
        event => {
          deleteRes(event, item);
        }
      "
    >
      <span class="name">
        {{ item.name }}
      </span>
      <span class="value">
        <span v-if="item.value && item.value.length === 0">
          暂未抽奖
        </span>
        <span
          class="card"
          v-for="(data, j) in item.value"
          :key="j"
          :data-res="data.name"
        >
          {{ data.name }}
        </span>
      </span>
    </div>
    <div style="text-align: center; margin: 20px 20px 0 20px;font-weight: bold;">广州华蝶信息技术有限公司为本系统提供技术支持</div>
  </el-dialog>
</template>
<script>
import { conversionCategoryName, getDomData } from '@/helper/index';
export default {
  name: 'c-Result',
  props: {
    visible: Boolean
  },
  computed: {
    result: {
      get() {
        return this.$store.state.result;
      },
      set(val) {
        this.$store.commit('setResult', val);
      }
    },
    resultList() {
      const list = [];
      for (const key in this.result) {
        // if (this.result.hasOwnProperty(key)) {
        //   const element = this.result[key];
        //   let name = conversionCategoryName(key);
        //   list.push({
        //     label: key,
        //     name,
        //     value: element
        //   });
        // }
        // 查看抽奖结果，显示名称而不是顺序数字
        if (this.result.hasOwnProperty(key)) {
          let element = this.result[key];

          let stateList = this.$store.state.list
          let element2 = []
          console.log('element', element)
          console.log('state.list', stateList)
          element.forEach(function(item){
              var val = stateList.find(d => d.name === item)
              val ?  val : (val = {key: item, name: item});
              element2.push(val)
          })
          element2.length > 0 ? element = element2 : '';

          let name = conversionCategoryName(key);
          list.push({
            label: key,
            name,
            value: element
          });
        }
      }
      console.log('list', list)
      return list;
    }
  },
  methods: {
    deleteRes(event, row) {
      const Index = getDomData(event.target, 'res');
      if (!Index) {
        return;
      }
      console.log('deleteRes--index', Index)
      this.$confirm('此操作将移除该中奖号码，确认删除?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (Index) {
            const result = this.result;
            console.log('deleteRes--result1', this.result)
            result[row.label] = this.result[row.label].filter(
                item => {
                    console.log('this.result[row.label]', item, typeof item)
                    return String(item) !== String(Index)
                }
            );
            this.result = result;
            console.log('deleteRes--result2', this.result)
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    }
  }
};
</script>
<style lang="scss">
.c-Result {
  .el-dialog__body {
    max-height: 500px;
    overflow-y: auto;
  }
  .listrow {
    display: flex;
    line-height: 30px;
    .name {
      width: 80px;
      font-weight: bold;
    }
    .value {
      flex: 1;
    }
    .card {
      display: inline-block;
      // width: 40px;
      padding: 0 5px;
      line-height: 30px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      border-radius: 4px;
      border: 1px solid #ccc;
      background-color: #f2f2f2;
      margin-left: 5px;
      margin-bottom: 5px;
      position: relative;
      cursor: pointer;
      &:hover {
        &::before {
          content: '删除';
          width: 100%;
          height: 100%;
          background-color: #ccc;
          position: absolute;
          left: 0;
          top: 0;
          color: red;
        }
      }
    }
  }
}
</style>
